import React, { ChangeEvent, useContext, useEffect, useState } from 'react';
import icon from '../../../../assets/shareholdersIcon.png';
import CustomInput from '../../../../components/CustomInputs/CustomInput';
import CustomSelectInput from '../../../../components/CustomSelectInput/CustomSelectInput';
import { Button, Checkbox, Dropdown, Label, Spinner, Textarea } from 'flowbite-react';
import client from '../../../../api/client';
import showToast from '../../../../components/CustomToast/toastHelper';
import CustomModal from '../../../../components/Modal/CustomModal';
import PayoutVerificationModal from '../PayoutVerificationModal/PayoutVerificationModal';
import { numberWithCommas } from '../../../../utils/formatNumber';
import { useCurrency } from '../../../../contexts/CurrencyContext';
import { Select } from '@mantine/core';
import { UserContext } from '../../../../contexts/UserContext';
import NotificationPopupModal from '../../../../components/NotificationPopupModal/NotificationPopupModal';
import OtpVerificationModal from '../../../../components/OtpVerificationModal/OtpVerificationModal';
import logo from '../../../../assets/Ideos.png'

interface ModalProps {
    close: () => void;
    onSuccess: () => void;
}

const MakeTransferModal = ({ close, onSuccess }: ModalProps) => {
    const { userDetails } = useContext(UserContext) ?? {};
    const [beneficiaries, setBeneficiaries] = useState<any[]>([]);
    const [selectedBeneficiary, setSelectedBeneficiary] = useState<any>(null);
    const [banks, setBanks] = useState<any[]>([]);
    const [account, setAccount] = useState({ accountName: "" });
    const [resolved, setResolved] = useState<boolean>(false);
    const [resolving, setResolving] = useState<boolean>(false)
    const [sendingOtp, setSendingOtp] = useState<boolean>(false)
    const [openOtpModal, setOpenOtpModal] = useState<boolean>(false)
    const [openPinOtpModal, setOpenPinOtpModal] = useState<boolean>(false)
    const [openPinModal, setOpenPinModal] = useState<boolean>(false)
    const [inputs, setInputs] = useState({
        accountNumber: "",
        bankCode: "",
        type: "",
        amount: "",
        description: "",
        creditCurrency: "",
        debitCurrency: "",
        beneficiaryAddress: ""
    });
    const [allGood, setAllGood] = useState<boolean>(false)
    const isFormValid = () => {
        if (useBeneficiary === 'Yes') {
            if (selectedBeneficiary !== null && inputs.amount !== "") {
                setAllGood(true);
            }
        } else {
            if (type === "Bank") {
                if (inputs.accountNumber.length === 10 && inputs.bankCode !== "" && inputs.amount !== "" && account.accountName != "") {
                    setAllGood(true);
                }
            } else if (type === "Merchant") {
                if (inputs.accountNumber !== "" && inputs.amount !== "") setAllGood(true);

            }
        }
    };

    const beneficiaryTypes = ["Bank", "Merchant"];
    const [type, setType] = useState(beneficiaryTypes[0]);
    const [currencies, setCurrencies] = useState<any[]>([]);
    const [useBeneficiary, setUseBeneficiary] = useState('Yes');
    const [batchId, setBatchId] = useState<Number>(1)
    const [loading, setLoading] = useState<boolean>(false)
    const [saveBeneficiary, setSavebeneficiary] = useState<boolean>(false)
    const { currency } = useCurrency()

    const handleTypeChange = (selectedType: string) => {
        setType(selectedType);
        setInputs({ ...inputs, type: selectedType });
    };

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setInputs({ ...inputs, [name]: value });
    };


    useEffect(() => {
        const fetchData = async () => {
            await fetchBeneficiaries();
            await fetchBanks();
            await getCurrencies();
        };
        fetchData();
    }, []);

    const fetchBeneficiaries = async () => {
        try {
            const apiUrl = '/subsidiary/beneficiary/all';
            const response = await client.get(apiUrl);
            setBeneficiaries(response.data.data.items);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const fetchBanks = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/banks');
            const message = response?.data?.message;
            setBanks(response.data.banks);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    useEffect(() => {
        if (useBeneficiary === 'No') {
            if ((type === "Bank" && inputs.accountNumber.length === 10) || (type === "Merchant" && inputs.accountNumber.length >= 1)) {
                setResolving(true)
                resolveAccount();
            } else {
                setResolved(false);
            }
        }
    }, [inputs.accountNumber, inputs.bankCode]);

    const resolveAccount = async () => {
        const payload = {
            accountNumber: inputs.accountNumber,
            bankCode: inputs.bankCode,
            type: inputs.type
        };
        try {
            const response = await client.post('/subsidiary/beneficiary/resolve', payload);
            setAccount(response.data.data);
            setResolved(true);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
        finally {
            setResolving(false);
        }
    };

    const handleBeneficiaryChange = (selectedBeneficiaryId: any) => {
        const beneficiary = beneficiaries.find(b => b.id == selectedBeneficiaryId);
        setSelectedBeneficiary(beneficiary);
        setInputs({
            ...inputs,
            accountNumber: beneficiary?.accountNumber || "",
            bankCode: beneficiary?.bankCode || "",
            type: beneficiary?.type || "",
            amount: beneficiary?.amount || "",
            creditCurrency: beneficiary?.creditCurrency || "",
            debitCurrency: beneficiary?.debitCurrency || "",
            beneficiaryAddress: beneficiary?.address || ""
        });
    };

    const getCurrencies = async () => {
        try {
            const response = await client.get('/subsidiary/dashboard/service/currencies');
            setCurrencies(response.data.data);
        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }
    };

    const handleUseBeneficiaryChange = (selectedOption: string) => {
        setAllGood(false)
        setUseBeneficiary(selectedOption);
        setInputs({
            accountNumber: "",
            bankCode: "",
            type: "",
            amount: "",
            description: "",
            creditCurrency: "",
            debitCurrency: "",
            beneficiaryAddress: ""
        })
        setSelectedBeneficiary(null)

    };

    const addBeneficiary = async () => {
        const bankInfo = banks.find(bank => bank.bankCode == inputs.bankCode);
        console.log(bankInfo);

        const payload = {
            AccountName: account.accountName,
            accountNumber: inputs.accountNumber,
            bankId: bankInfo.id,
            countryId: 1,
            type: inputs.type
        }

        try {
            const response = await client.post('/subsidiary/beneficiary/create', payload);
            const message = response?.data?.message;

        } catch (err: any) {
            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                const message = err?.response?.data?.message;
                console.error('error getting data', err);
                showToast(message, "error");
            }
        }

    }

    const initiatePayout = async () => {
        if (userDetails?.user?.pin == null && userDetails?.activeSubsidiary?.verificationStatus == "Active") {
            setOpenPinModal(true)
        } else {
            setLoading(true)
            const payload = {
                payoutDetails: [
                    {
                        accountNumber: inputs.accountNumber,
                        bankCode: useBeneficiary === "Yes"
                            ? selectedBeneficiary.bankCode
                            : type === "Bank"
                                ? inputs.bankCode
                                : "merchant",
                        amount: parseFloat(inputs.amount),
                        description: inputs.description,
                        type: type,
                        accountName: useBeneficiary == "No" ? account.accountName : selectedBeneficiary.name,
                        creditCurrency: inputs.creditCurrency,
                    }
                ]
            };

            try {
                const response = await client.post('/subsidiary/payout/initiate', payload);
                const message = response?.data?.message;
                showToast(message, "success");
                console.log(response?.data.data[0]);
                localStorage.setItem("payoutData", JSON.stringify(response?.data.data[0].payoutReference))

                //close();
                setBatchId(response.data.batchId)
                saveBeneficiary && addBeneficiary()
                setOpenOtpModal(true)
            } catch (err: any) {
                if (err?.response?.data?.message === 'Please login again') {
                    sessionStorage.clear();
                    window.location.href = '/';
                } else {
                    const message = err?.response?.data?.message;
                    console.error('error getting data', err);
                    showToast(message, "error");
                }
            }
            finally {
                setLoading(false)
            }
        }

    };

    const selectData = banks.map(bank => ({
        label: bank.name,
        value: bank.bankCode
    }))

    useEffect(() => {
        isFormValid()

    }, [inputs.accountNumber, useBeneficiary, inputs.amount, inputs.bankCode, selectedBeneficiary])

    const handleSendOtp = async () => {
        try {
            setSendingOtp(true)
            const response = await client.post('/subsidiary/dashboard/pin/reset/send-otp', null);
            const message = response?.data?.message;
            showToast(message, "success")
        } catch (err: any) {

            if (err?.response?.data?.message === 'Please login again') {
                sessionStorage.clear();
                window.location.href = '/';
            } else {
                console.error('error getting data', err);
                const message = err?.response?.data?.message;
                showToast(message, "error")
            }
        }
        finally {
            setSendingOtp(false)
        }
    }
    const handleCallToAction = () => {
        // if(type == 'intro'){
        //   setType('pinCreationMessage')
        // }
        // else if(type == "pinCreationMessage"){
        setType('pinCreationMessage')
        handleSendOtp()
        setOpenPinModal(false)
        setOpenPinOtpModal(true)
        // }
    }

    useEffect(() => {
        if (userDetails) {
            console.log(userDetails);

            if (userDetails?.user?.pin == null && userDetails?.activeSubsidiary?.verificationStatus == "Active") {
                setOpenPinModal(true)
            }
        }
    }, [])
    return (
        <div>
            <div className='h-full bg-green-50 p-4 '>
                <img src={icon} alt="icon" />
                <p className='font-semibold py-2'>Transfers</p>
                <p className='text-sm'>Kindly fill in the information needed</p>
            </div>
            <div className='my-4'>
                <div className='my-2'>
                    <CustomSelectInput label='Use beneficiary' items={["Yes", "No"]} onChange={handleUseBeneficiaryChange} />
                </div>
                {useBeneficiary === 'Yes' && (
                    <>
                        <div className='my-2'>
                            <CustomSelectInput
                                label='Choose beneficiary'
                                items={beneficiaries.map(b => ({ id: b.id, name: b.name }))}
                                displayKey='name'
                                valueKey='id'
                                onChange={(selectedOption: any) => handleBeneficiaryChange(selectedOption)}
                            />
                        </div>
                        <div>
                            {selectedBeneficiary && (
                                <div className='text-sm text-green-800'>
                                    <p >Account Name: <span>{selectedBeneficiary.name}</span></p>
                                    <p>Account Number: <span>{selectedBeneficiary.accountNumber}</span></p>
                                    <p>Bank Name: <span>{selectedBeneficiary.bankName}</span></p>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {useBeneficiary === 'No' && (
                    <>

                        <div className='my-2'>
                            <CustomSelectInput label='Type' items={beneficiaryTypes} onChange={handleTypeChange} />
                        </div>
                        {type === "Bank" ? (
                            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>

                                <CustomSelectInput
                                    isSearchable
                                    label='Bank Name'
                                    name='bankName'
                                    items={banks}
                                    value={inputs.bankCode}
                                    valueKey='bankCode'
                                    displayKey='name'
                                    onChange={(selectedOption: string) => setInputs({ ...inputs, bankCode: selectedOption })}
                                />
                                <CustomInput
                                    label='Account Number'
                                    name='accountNumber'
                                    value={inputs.accountNumber}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setInputs({ ...inputs, accountNumber: e.target.value })}
                                />
                            </div>
                        ) : type === "Merchant" ? (
                            <div>
                                <CustomInput
                                    name='Merchant Id'
                                    label='Merchant Id'
                                    value={inputs.accountNumber}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setInputs({ ...inputs, accountNumber: e.target.value })}
                                />
                            </div>
                        ) : null}
                        {resolving && (
                            <div className="absolute inset-0 z-50 flex items-center justify-center bg-white/70">
                                <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                            </div>
                        )}
                        {/* {resolving && <div className='text-xs text-green-500'><Spinner size='sm' /> Verifying account details</div>} */}
                        {resolved && (
                            <div className='text-xs'>
                                <span>Account Name: </span>
                                <span className='text-sm text-green-600'>{account.accountName}</span>
                            </div>
                        )}
                    </>
                )}
                <div className='mt-2 flex items-center gap-3'>
                    {/* <CustomSelectInput label='Currency' items={currencies} displayKey='shortName' valueKey='shortName' onChange={(selectedOption: string) => setInputs({ ...inputs, creditCurrency: selectedOption })} /> */}
                    <p className='text-sm'>Currency</p>-
                    <p className='text-sm text-green-800'>{currency}</p>
                </div>
                <div className='my-2'>
                    <CustomInput type='number' label='Amount' name='amount' value={inputs.amount} onChange={handleInputChange} />
                </div>
                <div>
                    <Label value='Description' htmlFor='description' />
                    <Textarea
                        id='description'
                        rows={4}
                        value={inputs.description}
                        onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setInputs({ ...inputs, description: e.target.value })}
                    />
                </div>
            </div>
            {useBeneficiary === 'No' && (<div className='flex items-center gap-3 my-3'>
                <Checkbox checked={saveBeneficiary} onChange={() => setSavebeneficiary(!saveBeneficiary)} />
                <p>Save as beneficiary</p>
            </div>)}

            <div className='flex gap-3'>
                <button className='border w-full md:w-1/4 py-1 rounded-lg text-lg font-semibold' onClick={() => close()}>
                    Cancel
                </button>
                <Button className={`border ${allGood ? ' hover:text-white' : ''} w-full md:w-3/4 text-black py-1 rounded-lg bg-custom-button-green text-lg `} onClick={initiatePayout} disabled={allGood == false}>
                    {loading ? <Spinner /> : 'Initiate Payout'}
                </Button>
            </div>

            <CustomModal title='Verify Payout' dismissible show={openOtpModal} icon='' onClose={() => setOpenOtpModal(false)} size='md'>
                <PayoutVerificationModal close={close} onSuccessfulVerification={onSuccess} batchId={batchId} />
            </CustomModal>
            <CustomModal title='' size='md' show={openPinModal} dismissible icon='' onClose={() => setOpenPinModal(false)}>
                <NotificationPopupModal type={type} close={() => setOpenPinModal(false)} action={() => { handleCallToAction() }} message={'You need to create a PIN to carry out transactions'} buttonText={loading ? <Spinner /> : 'Send code'} />
                {/* <CreatePinModal type='create' onSuccess={()=> setOpenPinModal(false)} message='Create Your PIN' buttonText=''/> */}
            </CustomModal>
            <CustomModal title='' size='md' show={openPinOtpModal} icon='' onClose={() => setOpenPinOtpModal(false)} dismissible>
                <OtpVerificationModal closeAllModals={() => { setOpenPinOtpModal(false) }} close={() => setOpenPinOtpModal(false)} />
            </CustomModal>

            {loading && (
                <div className="inset-0 z-50 flex items-center justify-center bg-white/70">
                    <img src={logo} alt="Loading..." className="w-16 animate-spin" />
                </div>
            )}
        </div>
    );
};

export default MakeTransferModal;
